import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MeterExportService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public post(exportRequest: any) {
    return this.http.post(this.endpoint(`api`, `meterexport`), exportRequest);
  }
}
